import * as React from 'react';
import { FC } from 'react';

interface AddRatingModel {
    contentId: string,
}

const AddRating: FC<AddRatingModel> = (props) => {
    const localstoragerating = localStorage.getItem(`reciperating_${props.contentId.toString()}`);
    let userrating = localstoragerating ? parseInt(localstoragerating) : 0;

    const [hoverRating, setHoverRating] = React.useState(userrating);

    const handleClick = async (i: number) => {
        const newRating = i + 1;

        if(userrating > 0){
            try {
                const response = await fetch('/api/recipes/updaterating', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        pageid: props.contentId.toString(),
                        score: newRating,
                        oldscore: userrating
                    })
                });

                if (!response.ok) {
                    throw new Error('Something went wrong');
                }
            } catch (error) {
                console.error('Fetch error:', error);
            }
        } else {
            try {
                const response = await fetch('/api/recipes/addrating', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        pageid: props.contentId.toString(),
                        score: newRating
                    })
                });

                if (!response.ok) {
                    throw new Error('Something went wrong');
                }
            } catch (error) {
                console.error('Fetch error:', error);
            }
      }
      userrating = newRating;
      localStorage.setItem(`reciperating_${props.contentId.toString()}`, newRating.toString());
    }

    return (
        <ul className="flex flex-row gap-2 justify-center" onMouseLeave={() => setHoverRating(userrating)}>
            {Array.from({ length: 5 }, (_, i) => (
                <li key={i}>
                    <button type="button" title={`${i + 1} ${i + 1 > 1 ? 'stjerner' : 'stjerne'}`} className="rounded bg-orange-50 p-2 active:bg-orange-25 transition-all focus:outline-red-secondary" onMouseOver={() => setHoverRating(i + 1)} onClick={() => handleClick(i)}>
                        <svg width="36" height="35" viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg" className='w-6 h-auto'>
                            <path id="star" d="M6.885 34.4065L9.81 21.7615L0 13.2565L12.96 12.1315L18 0.206543L23.04 12.1315L36 13.2565L26.19 21.7615L29.115 34.4065L18 27.7015L6.885 34.4065Z" fill={hoverRating > i ? '#F79B1A' : '#FDEDDB'}/>
                        </svg>
                    </button>
                </li>
            ))}
        </ul>
    );
};
export default AddRating;